import Api from 'shared/core/api'

export default {
  signUp (data) {
    const resource = '/users/create'
    return Api().post(`${resource}`, data);
  },
  delete (userId) {
    const resource = `/users/${userId}`;
    return Api().delete(`${resource}`);
  },
  verify (data) {
    const userId = data.userId;
    const resource = `/users/${userId}/verify`;
    const params = {
      verification_code: data.verificationCode
    }
    return Api().get(`${resource}`, { params });
  },
  resendVerificationEmail (data) {
    const resource = '/users/request_verification';
    const params = {
      user_id: data.userId
    }
    return Api().get(`${resource}`, { params });
  },
  login (data) {
    const resource = '/users/login'
    return Api().post(`${resource}`, data);
  },
  logout () {
    const resource = 'users/me/logout'
    return Api().get(`${resource}`);
  },
  getUser () {
    const resource = '/users/me'
    return Api().get(`${resource}`);
  },
  getUserById (userId) {
    const resource = '/users'
    return Api().get(`${resource}/${userId}`, { params: { expand: 'backgroundPoi' } });
  },
  subscribe (data) {
    const resource = '/users/subscribe';
    return Api().post(`${resource}`, data);
  },
  requestResetPassword (data) {
    const resource = '/users/request_reset_password';
    return Api().get(`${resource}`, { params: data });
  },
  resetPassword (data) {
    const userId = data.userId;
    const postData = {
      reset_code: data.resetCode,
      password: data.password
    };
    const resource = `/users/${userId}/reset_password`;
    return Api().post(`${resource}`, postData);
  },
  requestFacebookDisconnect (data) {
    const resource = `/facebook/request-disconnect/${data.email}`;
    return Api().get(`${resource}`);
  },
  facebookDisconnect (data) {
    const resource = `/facebook/disconnect/${data.userId}/${data.disconnectCode}`;
    return Api().get(`${resource}`);
  },
  getNewsletterSubscriptions () {
    const resource = '/users/me/subscriptions';
    return Api().get(`${resource}`);
  },
  getStruinenSubscriptions () {
    const resource = '/users/me/struinen-subscriptions';
    return Api().get(`${resource}`);
  },
  postNewsletterSubscriptions () {
    const resource = '/users/me/subscriptions';
    return Api().post(`${resource}`);
  },
  postStruinenSubscriptions () {
    const resource = '/users/me/struinen-subscriptions';
    return Api().post(`${resource}`);
  },
  deleteNewsletterSubscriptions () {
    const resource = '/users/me/subscriptions';
    return Api().delete(`${resource}`);
  },
  deleteStruinenSubscriptions () {
    const resource = '/users/me/struinen-subscriptions';
    return Api().delete(`${resource}`);
  },
  getAnnualTickets () {
    const resource = '/users/me/abonnement-registraties?paginate=100';
    return Api().get(`${resource}`);
  },
  getAnnualTicket (ticketId) {
    const resource = `/users/me/abonnement-registraties/${ticketId}`;
    return Api().get(`${resource}`);
  },
  getParkingTicketExtensions () {
    const resource = '/users/me/parkeerkaart-verlengingen';
    return Api().get(`${resource}`, { params: { status: 'goedgekeurd' } });
  },
  update (data) {
    const resource = '/users/me'
    return Api().put(`${resource}`, data);
  }
}
